export default __webpack_public_path__ + "static/media/icon-otter.ee83b6b0.png";